import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsTrigger, Collapse, CollapseProvider, CollapseToggle, CollapseTrigger, List, ListItem, Separator, Text } from 'telia-front-react';
import RoamingStore from '../../../stores/RoamingStore';
import { TranslationsContext } from '@teliaee/telia-translate';

interface ServiceGroupNotesProps {
  serviceGroupId: number;
  type: 'calls' | 'internet';
  roamingStore?: RoamingStore;
}

const ServiceGroupNotes = (props: ServiceGroupNotesProps): JSX.Element => {
  const { translate } = React.useContext(TranslationsContext);
  const {
    roamingStore: { selectedOperatorServiceGroupById, selectedCountry, selectedOperator },
    type,
    serviceGroupId
  } = props;
  const serviceGroup = selectedOperatorServiceGroupById(serviceGroupId);
  const service = type === 'calls' ? 'Kõned ja Sõnumid' : 'Internet';
  const analyticsId = `Link - ${selectedCountry.isoCode} - ${selectedOperator.name} - ${service} - Loen lähemalt`;

  if (!serviceGroup.groupNotes?.length) {
    return null;
  }

  return (
    <>
      <Separator spacing="xxsmall" weight="thin" />
      <Separator spacing="xsmall" color="invisible" />
      <Text>
        <AnalyticsTrigger trigger={{ id: analyticsId, callback: 'onToggle' }}>
          <CollapseProvider id={`${type}-notes`}>
            <CollapseTrigger>
              <CollapseToggle text={translate('roaming.operator.read-more')} link={true} iconRight="#arrow-down" />
            </CollapseTrigger>
            <Collapse noClose={true}>
              <List>
                {serviceGroup.groupNotes.map((note, i) => (
                  <ListItem key={`note-group-${serviceGroupId}-${i}`}>{note.notePrompt}</ListItem>
                ))}
              </List>
            </Collapse>
          </CollapseProvider>
        </AnalyticsTrigger>
      </Text>
    </>
  );
};

export default inject('roamingStore')(observer(ServiceGroupNotes));
